import TextBlock from "tds/textBlock";

export { TextBlock };

customElements.define("tds-text-block", TextBlock.CustomElementConstructor);
